import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

const el = document.getElementById('groutCalculator');
const locale = el.getAttribute('data-locale');
const country = el.getAttribute('data-country');
const context = el.getAttribute('data-context');
const groutKey = el.getAttribute('data-grout-key');

// window.dataLayer = window.dataLayer || [];

if (typeof(window.dataLayer) !== 'undefined') {
    // console.log('dataLayer defined');

    var dataLayer = window.dataLayer;
    // console.log(dataLayer);
}
// else
// {
//     console.log('dataLayer undefined');
// }

ReactDOM.render(<App locale={ locale || "en-AU" } context={ context || "int" } country={country || "uk"} groutKey={groutKey || null} dataLayer={dataLayer || null} />, el);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
